export const reviewsList = [
  {
    img: '/img/review-1.png',
    room: '1/2 комнатная кв. Урбан',
    text: `Расчёт ремонта квартиры онлайн. Укажите параметры вашей квартиры, затем в конструкторе выберите планируемый дизайн. 
С помощью системы наши клиенты могут отслеживать все этапы ведения ремонта.`,
    name: 'Меруерт',
    address: 'Нур-Султан, ЖК Nova City',
  },
  {
    img: '/img/review-2.png',
    room: '1/2 комнатная кв. Урбан',
    text: `Расчёт ремонта квартиры онлайн. Укажите параметры вашей квартиры, затем в конструкторе выберите планируемый дизайн. 
С помощью системы наши клиенты могут отслеживать все этапы ведения ремонта.`,
    name: 'Максат',
    address: 'Нур-Султан, ЖК Nova City',
  },
  {
    img: '/img/review-3.png',
    room: '1/2 комнатная кв. Урбан',
    text: `Расчёт ремонта квартиры онлайн. Укажите параметры вашей квартиры, затем в конструкторе выберите планируемый дизайн. 
С помощью системы наши клиенты могут отслеживать все этапы ведения ремонта.`,
    name: 'Дастан',
    address: 'Нур-Султан, ЖК Nova City',
  },
  {
    img: '/img/review-4.png',
    room: '1/2 комнатная кв. Урбан',
    text: `Расчёт ремонта квартиры онлайн. Укажите параметры вашей квартиры, затем в конструкторе выберите планируемый дизайн. 
С помощью системы наши клиенты могут отслеживать все этапы ведения ремонта.`,
    name: 'Анита',
    address: 'Нур-Султан, ЖК Nova City',
  },
];
